import { render } from "./alert.vue?vue&type=template&id=ba762414&ts=true"
import script from "./alert.component.ts?vue&type=script&lang=ts"
export * from "./alert.component.ts?vue&type=script&lang=ts"

import exportComponent from "D:\\trainsit project\\LTMS\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__